import currencyFormatter from "currency-formatter"
import HTMLReactParser from "html-react-parser"
import moment from "moment"

/* eslint-disable no-bitwise */
const keyStr =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="

const triplet = (e1, e2, e3) =>
  keyStr.charAt(e1 >> 2) +
  keyStr.charAt(((e1 & 3) << 4) | (e2 >> 4)) +
  keyStr.charAt(((e2 & 15) << 2) | (e3 >> 6)) +
  keyStr.charAt(e3 & 63)

export const rgbDataURL = (r, g, b) =>
  `data:image/gif;base64,R0lGODlhAQABAPAA${
    triplet(0, r, g) + triplet(b, 255, 255)
  }/yH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==`

export const shimmer = (w, h) => `
  <svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <linearGradient id="g">
        <stop stop-color="#333" offset="20%" />
        <stop stop-color="#222" offset="50%" />
        <stop stop-color="#333" offset="70%" />
      </linearGradient>
    </defs>
    <rect width="${w}" height="${h}" fill="#333" />
    <rect id="r" width="${w}" height="${h}" fill="url(#g)" />
    <animate xlink:href="#r" attributeName="x" from="-${w}" to="${w}" dur="1s" repeatCount="indefinite"  />
  </svg>`

export const extractMeta = (meta, key) => {
  const result = meta
    ?.filter((item) => item.section === key)
    ?.reduce((obj, item) => Object.assign(obj, { [item.key]: item.value }), {})
  return result
}

export const imgUrl = (path) =>
  path ? `${process.env.STORAGE_URL}/${path}` : "/img/dummy/img_dummy.jpeg"

export const imgUrlDownload = (filename) =>
  `${process.env.CMS_URL}/mediakit/download?path=/${filename}`

export const convertJson = (value) => {
  try {
    const result = JSON.parse(value)
    return result
  } catch {
    return value
  }
}

export const formatDate = (date) => moment(date).format("DD.MM.YYYY")

export const convertHtmlToReact = (data) => {
  if (data && typeof data === "string") return HTMLReactParser(data)
  return data
}

export const getYoutubeEmbedUrl = (url) => {
  if (url) {
    if (url.includes("embed")) {
      return url
    }
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
    const match = url.match(regExp)

    const id = match && match[2].length === 11 ? match[2] : null

    return `https://www.youtube.com/embed/${id}`
  }
  return ""
}

export const groupedByYear = (list, orderBy) =>
  list
    .reduce((acc, curr) => {
      const year = curr?.year || moment(curr?.date).year()
      const existingYear = acc.find((item) => item.year === year)

      if (existingYear) {
        existingYear.data.push(curr)
      } else {
        acc.push({ year, data: [curr] })
      }

      return acc
    }, [])
    .sort((a, b) => {
      if (orderBy === "oldest") {
        return a.year - b.year
      }
      return b.year - a.year
    })

export function formatFileSize(bytes) {
  const kilobytes = bytes / 1024
  const megabytes = kilobytes / 1024

  if (!bytes) {
    return `0 MB`
  }

  if (megabytes >= 1) {
    return `${megabytes.toFixed(2)} MB`
  }
  if (kilobytes >= 1) {
    return `${kilobytes.toFixed(2)} KB`
  }
  return `${bytes} bytes`
}

export function governanceText(date, file) {
  return `${moment(date).format("DD MMMM YYYY")} • ${formatFileSize(
    file?.size
  )} • ${file?.extension?.toUpperCase()}`
}

export function filterReportData(data, locale) {
  return data?.filter((item) => {
    const meta = extractMeta(item.meta, "report")
    const file = convertJson(meta[`file_${locale}`])
    return file?.size || file?.extension || file?.path
  })
}

export function sortReportData(data, orderBy) {
  if (data?.length) {
    const result = [...data]
    result.sort((a, b) => {
      if (orderBy === "oldest") {
        return moment(a.published_at) - moment(b.published_at)
      }
      return moment(b.published_at) - moment(a.published_at)
    })
    return result
  }
  return []
}

export const FormatCurrency = (num, language) =>
  currencyFormatter.format(num, {
    code: "IDR",
    locale: language === "id" ? "id-ID" : "en-US",
    precision: 0,
  })

export const FormatShares = (num, language) =>
  currencyFormatter.format(num, {
    symbol: "",
    thousand: language === "id" ? "." : ",",
    precision: 0,
  })

export function isEmpty(str) {
  return !str || str?.length === 0
}
